"use client";

import { DatePickerV2 } from "components/ui/v2/date-picker-v2";

export interface DateRangePickerV2Props {
  from: Date | null;
  to: Date | null;
  onChange: (range: { from: Date | null; to: Date | null }) => void;
  fromLabel?: string;
  toLabel?: string;
  className?: string;
}

export function DateRangePickerV2({
  from,
  to,
  onChange,
  fromLabel = "Desde",
  toLabel = "Hasta",
  className,
}: DateRangePickerV2Props) {
  return (
    <div className={`flex items-center gap-2 ${className || ""}`}>
      <div className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-500 dark:text-slate-400">
          {fromLabel}
        </span>
        <DatePickerV2
          value={from}
          onChange={(date) => onChange({ from: date, to })}
        />
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-500 dark:text-slate-400">
          {toLabel}
        </span>
        <DatePickerV2
          value={to}
          onChange={(date) => onChange({ from, to: date })}
        />
      </div>
    </div>
  );
}
